module.exports = __webpack_public_path__ + "img/baoyou.c6971190.png";